import { useSelector } from "react-redux";

import AArsrapportLists from "./AArsrapportLists";

function AArsrapportListsContainer(ownProps) {
  const aarsrapport = useSelector((state) => state.rapporter.aarsrapport);

  return <AArsrapportLists {...ownProps} aarsrapport={aarsrapport} />;
}

export default AArsrapportListsContainer;
